class PfProductAccordion extends HTMLElement {
  constructor() {
    super();
    this._controller = null;
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    this.destroy();
  }

  get items() {
    return [...this.querySelectorAll(".pf-accordion-item")];
  }

  get activeIndex() {
    return this.items.findIndex(item =>
      item.classList.contains("pf-active")
    );
  }

  set activeIndex(index) {
    this.items.forEach((item, i) =>
      item.classList.toggle("pf-active", i === index)
    );
  }

  init() {
    this._controller = new AbortController();
    const { signal } = this._controller;

    this.items.forEach((item, index) => {
      item.querySelector(".pf-accordion-head")?.addEventListener(
        "click",
        () => this.toggle(index),
        { signal }
      );
    });
  }

  destroy() {
    this._controller?.abort();
  }

  toggle(index) {
    this.activeIndex = this.activeIndex === index ? -1 : index;
  }
}

if (!customElements.get("pf-product-accordion")) {
  customElements.define("pf-product-accordion", PfProductAccordion);
}